<template>
    <div>
        <nav :class="{scroll: isScroll}">
            <ul>
                <li><a :class="{active: navName==='home'}" @click="home">首页</a></li>
                <li><a :class="{active: navName==='nan'}" @click="nan">男频</a></li>
                <li><a :class="{active: navName==='nv'}" @click="nv">女频</a></li>
                <li><a :class="{active: navName==='shuku'}" @click="shuku">书库</a></li>
                <li><a :class="{active: navName==='paihang'}" @click="paihang">排行</a></li>
                <li><a :class="{active: navName==='chongzhi'}" @click="chongzhi">充值</a></li>
                <li><a :class="{active: navName==='author'}" @click="author">作者中心</a></li>
                <li><a :class="{active: navName==='news'}" @click="news">作者福利</a></li>
            </ul>
        </nav>
    </div>

</template>

<script>
    export default ({
        data () {
            return {
                navName: 'home',
                scrollTop: '',
                isScroll: false
            }
        },
        mounted () {
            window.addEventListener('scroll', this.handleScroll, true);
            this.navName = this.$route.name ? this.$route.name : 'home';
        },
        watch: {
            '$route' () {
                this.navName = this.$route.name ? this.$route.name : 'home';
            }
        },
        methods: {
            handleScroll () {
                this.scrollTop = document.documentElement.scrollTop ||
                    window.pageYOffset ||
                    document.body.scrollTop;
                if (this.scrollTop > 300) {
                    this.isScroll = true
                } else {
                    this.isScroll = false;
                }
            },
            home() {
                window.open('http://www.iyoule.com');
            },
            nan() {
                window.open('http://www.iyoule.com/pindao/nan.html');
            },
            nv() {
                window.open('http://www.iyoule.com/pindao/nv.html');
            },
            shuku() {
                window.open('http://www.iyoule.com/shuku.html');
            },
            paihang() {
                window.open('http://www.iyoule.com/paihang/nan/7.html');
            },
            chongzhi() {
                window.open('http://www.iyoule.com/chongzhi.html');
            },
            author() {
                window.open('http://www.iyoule.com/author.php');
            },
            news () {
                this.$router.push({path: `/news/5/21`});
            }
        }
    })
</script>
<style lang="less" scoped>
    @import "../../assets/css/index";
    nav {
        width: 100%;
        height: 44px;
        background: #3e3d43;
        ul {
            display: flex;
            width: 820px;
            height: 100%;
            margin: 0 auto;
            justify-content: center;
            align-items: center;
            li {
                a {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 16px;
                    line-height: 42px;
                    font-weight: bold;
                    height: 42px;
                    padding: 0 30px;
                    border-bottom: 2px solid #333;
                }
                a.active{
                    background: #ffffff;
                    color: @c-youlered;
                }
            }
        }
    }
    nav.scroll {
        width: 100%;
        position: fixed;
        justify-content: center;
        top: 0;
        z-index: 99;
        transition: all 0.3s;
    }
    @media screen and (max-width: 768px) {
        nav {
            height: auto;
            ul {
                width: 100%;
                flex-wrap: wrap;
            }
        }
    }
</style>
